import { useQuery } from "@tanstack/react-query";
import { listProgrammes, type ProgrammeSearchParams } from "../api/programmesApi";
import { queryKeys } from "../lib/queryKeys";

export function useProgrammesList(params: ProgrammeSearchParams) {
  return useQuery({
    queryKey: queryKeys.programmes.list(params),
    queryFn: () => listProgrammes(params),
  });
}
